import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useReassessApplication = (
  isLoading,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isApplicationStatusAllowed =
    ['REASSESSING'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isApplicationStatusAllowed;

  const showComponent = isAllowed;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to reassess this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  const component = showComponent ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Reassess Application
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useReassessApplication;
